import { CHANGE_PASSWORD_PATH, LOGIN_PATH, RESET_PASSWORD_PATH } from '../services/path';
import {
  LOGIN, LOGOUT, RESET_PASS, SEND_EMAIL, SET_TOKEN
} from './types';
import { api, saveTokenAuthentication } from '../services/api';
import { showErrorMessage, showSuccessMessage } from '../utils/utils';
import { setUserHeader } from './user';
import { cargarPrivilegiosAlLogin } from './auth';

const setToken = (tokens) => (dispatch) => dispatch({
  type: SET_TOKEN,
  tokens,
  meta: {
    onSuccess: () => {
      saveTokenAuthentication(tokens);
    }
  }
});
const login = (nombre, password) => (dispatch) => {
  // Detectar zona horaria del navegador automáticamente
  const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone || 'America/Mexico_City';
  
  return dispatch({
    type: LOGIN,
    promise: api.post(LOGIN_PATH, {
      nombre,
      password,
      timezone,  // ← Enviar timezone al backend
    }),
    meta: {
      onSuccess: async (res) => {
        saveTokenAuthentication(res.data.tokens);
        
        // Obtener el id del usuario autenticado
        const usuarioId = res.data?.user?._id || res.data?.user?.id;
        if (usuarioId) {
          await dispatch(cargarPrivilegiosAlLogin(usuarioId));
        } else {
          // Fallback: solo refresca user
          dispatch(setUserHeader());
        }
      },
      onFailure: (res) => {
        showErrorMessage(res.response.data.message, dispatch);
      }
    }
  });
};

const logout = () => (dispatch) => dispatch({
  type: LOGOUT,
});

const sendEmail = (email, callback) => (dispatch) => dispatch({
  type: SEND_EMAIL,
  promise: api.post(RESET_PASSWORD_PATH, {
    email
  }),
  meta: {
    onSuccess: (res) => {
      showSuccessMessage(res.data.message, dispatch);
      callback();
    },
    onFailure: (res) => {
      showErrorMessage(res.response.data.message, dispatch);
      callback();
    }

  }
});
const newPassword = (data) => (dispatch) => dispatch({
  type: RESET_PASS,
  promise: api.post(CHANGE_PASSWORD_PATH, data),
  meta: {
    onSuccess: (res) => {
      showSuccessMessage(res.data.message, dispatch);
    },
    onFailure: (res) => {
      showErrorMessage(res.response.data.message, dispatch);
    }

  }
});
export {
  logout,
  login,
  setToken,
  sendEmail,
  newPassword
};
